import { gql } from 'apollo-boost'

const SCRAPING_SESSION = gql`
  query scrapingSession($id: ID!) {
    scrapingSession(id: $id) {
      id
      status
      startedAt
      completedAt
      createdBy {
        id
        name
      }
      scrapingTestCaseResultCount
    }
  }
`

export default SCRAPING_SESSION
